export default "__VITE_PUBLIC_ASSET__69bc5019__"